import { h } from "preact";
import { observer } from "mobx-react";
import { t, translate } from "restaumatic-client";
import { ModalHeader } from "../../components/PreactModal";
function CartHeader(props) {
    const { isClearVisible, onClear } = props;
    return (h(ModalHeader, { title: translate(t.restaurants.widgets.cart.name), closeLabel: translate(t.restaurants.widgets.cart.hide_and_continue), closeGaAction: "Close cart (X button clicks)", closeFieldId: "Cart.close", children: isClearVisible ? h(ClearButton, { onClear: onClear }) : null }));
}
function ClearButton(props) {
    return (h("button", { onClick: props.onClear, "data-ga-action": "Clear cart", "data-field-id": "Cart.clear", class: "btn-link u-text-transform-none u-p0 u-font-size-small" }, translate(t.restaurants.widgets.cart.clear)));
}
export default observer(CartHeader);
